import useNotification from '@/modules/notifications/stores/use-notification'
import useProfile from '@/modules/user/stores/use-profile'
import createStoreWithContext from '@/utils/store/create-store-with-context'

import ProgramApis from '../../apis'
import CheckoutApis from '../../apis/checkout'

const { withStore, useStore: useProgramRegistrationOptions } =
  createStoreWithContext(
    (set, get, swrFields) => ({
      ...swrFields,
      register: async (id, optionId) => {
        const { profile } = useProfile.getState()
        const { registrationOptions } = get()
        const option = registrationOptions.find(
          (o) => o.sk === `OPTION#${optionId}`,
        )

        const url = await CheckoutApis.createCheckoutWithItem(
          profile,
          option.shopifyVariantId,
        )

        if (url && typeof url === 'string') {
          window.location.assign(url)
        } else {
          useNotification
            .getState()
            .addNotification('error', 'Failed to checkout')
        }
      },
    }),
    (data, query) => ({
      key: `program-${query?.handle}-registration-options`,
      initialData: data,
      fetcher: () => ProgramApis.getRegistrationOptions(query?.handle),
      storeKey: 'registrationOptions',
    }),
  )

export const withProgramRegistrationOptionsStore = withStore

export default useProgramRegistrationOptions
